// extracted by mini-css-extract-plugin
export default {"pill":"pill__Pill__ms6l-"};